import { AppointmentsStoreState } from './appointments-store.type';

export const initialState: AppointmentsStoreState = {
  appointments: [],
};

export const STORE_NAME = 'APPOINTMENTS';
